<mat-dialog-content class="dialog-content">
  <div class="icon-wrapper">
    <mat-icon class="info-icon" color="primary">email</mat-icon>
  </div>

  <h2 class="title" data-testid="pcc-instructions-title">Check Your Email – Action Needed</h2>

  <div class="content">
    <p>
      We’ve sent you an email from <strong>FleetOperate</strong> with the subject:<br />
      <br />
      <em><strong>“Criminal Record (Background) Check [Action needed]”</strong></em>
    </p>
    <p>
      👉 Please <strong>check your inbox (and spam folder)</strong> for this email.<br />
      Follow the instructions to upload your <strong>driver’s license</strong> and a <strong>clear selfie.</strong>
    </p>

    <p class="warning">
      ⚠️ Blurry or unclear photos may delay your PCC application.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-flat-button color="primary" (click)="close()" data-testid="pcc-instructions-ok">OK</button>
</mat-dialog-actions>
